<template>
	<div class="reports-dashboard">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<FiveKReport  ref="fiveKReport" :meta-data="computedFiveKReportMetaData"  :data="computedFiveKReportData" :previous-data="computedFiveKReportPreviousData"/>
		<!-- <el-row>
			<el-col :span="1">
				<img
					@click="go_back_to_dashboard()"
					width="35px"
					src="../../../../assets/icons/Back Arrow.png"
					style="cursor: pointer; position: relative; z-index: 1"
				/>
			</el-col>
			<el-col
				style="
					margin-top: 0px;
					color: #999999;
					margin-left: -10px;
					font-size: 16px;
				"
				:span="10"
			>
				<div
					@click="go_back_to_dashboard()"
					style="cursor: pointer; position: relative; z-index: 1"
				>
					Back
				</div>
			</el-col>
		</el-row> -->
		<el-row style="margin-top: 10px">
			<el-col :span="24">
				<span style="font-weight: bold; text-transform: capitalize">
					{{ storeObj ? storeObj.name : "" }} Reports -
					{{
						project_tasksItems.filter((el) => el.id.includes(project_tasks))[0]
							.name
					}}
					<div>
						( {{ moment(from_date).format("Do MMM YYYY") }} -
						{{ moment(to_date).format("Do MMM YYYY") }} )
					</div></span
				>
			</el-col>
		</el-row>
		<el-row style="font-size: 16px; margin-top: 20px" :gutter="10">
			<el-col :span="24">
				<div style="background: white; padding: 5px">
					<el-row style="font-size: 16px; margin-top: 20px" :gutter="10">
						<el-col :span="24">
							<UserPerformanceGraphVue
								:labels="labels"
								:country_average="country_average"
								:region_average="region_average"
								:chart_data="chart_data"
								:chart_data1="chart_data1"
								:reportsTable="reportsTable"
							/>
						</el-col>
						<!-- <el-col :span="4" style="font-size: 12px">
							<el-row style="margin-top: 50px">
								<el-col :span="3">
									<div
										style="height: 15px; width: 15px; background-color: #d26300"
									></div>
								</el-col>
								<el-col :span="21">
									<div>
										{{
											project_tasksItems.filter((el) =>
												el.id.includes(project_tasks)
											)[0].name
										}}
									</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 15px; width: 15px; background-color: #eec383"
									></div>
								</el-col>
								<el-col :span="21">
									<div style="font-size: 13px">Completion %</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 5px; width: 15px; background-color: #ff4d01"
									></div>
								</el-col>
								<el-col :span="21">
									<div>Country Average</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 5px; width: 15px; background-color: #b2beb5"
									></div>
								</el-col>
								<el-col :span="21">
									<div>Region Average</div>
								</el-col>
							</el-row>
						</el-col> -->
					</el-row>
				</div>
			</el-col>
		</el-row>
		<div
			v-if="is_outlet"
			style="margin-top: 20px; background: white; padding: 5px"
		>
			<el-row style="margin-top: 20px; margin-left: 20px">
				<el-col :span="24">
					<span style="font-weight: bold; margin-top: 20px"> Reports</span>
				</el-col>
			</el-row>
			<el-row
				v-loading="isloading"
				class="reports-table3"
				style="margin-top: 14px"
			>
				<el-col :span="24">
					<el-table
						style="text-transform: capitalize; word-break: break-word"
						:data="
							reportsTable2
								.filter(
									(el) =>
										!selected_Date.length ||
										selected_Date.includes(
											moment(el.project_start_date).format('Do MMM YYYY')
										)
								)
								.filter(
									(el) =>
										!selected_end_Date.length ||
										selected_end_Date.includes(
											moment(el.project_end_date).format('Do MMM YYYY')
										)
								)
								.filter(
									(el) =>
										!selected_completion_Date.length ||
										selected_completion_Date.includes(
											moment(el.project_completion_date).format('Do MMM YYYY')
										)
								)

								.filter(
									(el) =>
										!selected_Employee.length ||
										selected_Employee.includes(el.name)
								)
								.filter(
									(el) =>
										!selected_Region.length ||
										selected_Region.includes(el.region)
								)
								.filter(
									(el) =>
										!selected_SubRegion.length ||
										selected_SubRegion.includes(el.subregion)
								)
								.filter(
									(el) =>
										!selected_Designation.length ||
										selected_Designation.includes(el.designation)
								)
								.filter(
									(el, index) => index >= startNumber - 1 && index < endNumber
								)
						"
					>
						<el-table-column width="150px" label="">
							<template slot="header" slot-scope="scope">
								Start Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Date">
											<el-checkbox
												v-for="(formItem, index) in uniqueDates.filter(
													(el) =>
														!searched_Date ||
														el
															.toLowerCase()
															.includes(searched_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Date = [...uniqueDates]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div>
									{{
										scope.row.project_start_date != 0
											? moment(scope.row.project_start_date).format(
													"Do MMM YYYY"
											  )
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="150px" label="">
							<template slot="header" slot-scope="scope">
								End Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_end_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_end_Date">
											<el-checkbox
												v-for="(formItem, index) in uniqueDatesEnd.filter(
													(el) =>
														!searched_end_Date ||
														el
															.toLowerCase()
															.includes(searched_end_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_end_Date = [...uniqueDatesEnd]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_end_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_end_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div>
									{{
										scope.row.project_end_date != 0
											? moment(scope.row.project_end_date).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="170px" label="">
							<template slot="header" slot-scope="scope">
								Completion Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_completion_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_completion_Date">
											<el-checkbox
												v-for="(
													formItem, index
												) in uniqueDatesCompletion.filter(
													(el) =>
														!searched_completion_Date ||
														el
															.toLowerCase()
															.includes(searched_completion_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="
												selected_completion_Date = [...uniqueDatesCompletion]
											"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_completion_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_completion_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div>
									{{
										scope.row.project_completion_date != 0
											? moment
													.utc(scope.row.project_completion_date)
													.local()
													.format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Employee">
							<template slot="header" slot-scope="scope">
								Employee
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Employee"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Employee">
											<el-checkbox
												v-for="(formItem, index) in uniqueEmployees.filter(
													(el) =>
														!searched_Employee ||
														el
															.toLowerCase()
															.includes(searched_Employee.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Employee = [...uniqueEmployees]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Employee = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Employee.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.name == 0 ? "-" : scope.row.name }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Designation">
							<template slot="header" slot-scope="scope">
								Designation
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Designation"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Designation">
											<el-checkbox
												v-for="(formItem, index) in uniqueDesignations.filter(
													(el) =>
														!searched_Designation ||
														el
															.toLowerCase()
															.includes(searched_Designation.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Designation = [...uniqueDesignations]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Designation = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Designation.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.designation == 0 ? "-" : scope.row.designation }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="150px" label="Region">
							<template slot="header" slot-scope="scope">
								Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Region"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Region">
											<el-checkbox
												v-for="(formItem, index) in uniqueRegions.filter(
													(el) =>
														!searched_Region ||
														el
															.toLowerCase()
															.includes(searched_Region.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Region = [...uniqueRegions]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Region = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Region.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.region }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Sub Region">
							<template slot="header" slot-scope="scope">
								Sub Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_SubRegion"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_SubRegion">
											<el-checkbox
												v-for="(formItem, index) in uniqueSubRegions.filter(
													(el) =>
														!searched_SubRegion ||
														el
															.toLowerCase()
															.includes(searched_SubRegion.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_SubRegion = [...uniqueSubRegions]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_SubRegion = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_SubRegion.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.subregion }}
								</div>
							</template>
						</el-table-column>
						<el-table-column
							v-if="show_score"
							width="150px"
							sortable
							prop="total_score"
							label="Total Points"
						>
						</el-table-column>
						<el-table-column
							v-if="show_score"
							width="180px"
							sortable
							prop="current_score"
							label="Points Achieved"
						>
						</el-table-column>
						<el-table-column
							v-if="show_score"
							width="150px"
							sortable
							prop=""
							label="Score %"
						>
							<template slot-scope="scope">
								{{ scope.row["completed_score_%"] }}%
							</template>
						</el-table-column>
						<el-table-column
							v-if="show_completion"
							width="160px"
							sortable
							prop="forms_completion_%"
							label="Completion %"
						>
							<template slot-scope="scope">
								{{ scope.row["forms_completion_%"] }}%
							</template>
						</el-table-column>
						<!-- <el-table-column fixed="right" width="180px">
							<template slot-scope="scope">
								<span
									:style="
										scope.row['forms_completion_%'] != 0
											? `cursor: pointer;
										color: #d26300;
										text-decoration: underline;`
											: ''
									"
									@click="
										scope.row['forms_completion_%'] != 0
											? downloadCsvReport(scope.row)
											: ''
									"
									>{{
										scope.row["forms_completion_%"] != 0
											? "Download Report"
											: "-"
									}}</span
								>
							</template>
						</el-table-column> -->
						<el-table-column fixed="right" width="180px">
							<template slot-scope="scope">
								<!-- <el-dropdown @command="handleCommand">
									<span class="el-dropdown-link"
									:style="{
										cursor: canDownload(scope.row) ? 'pointer' : 'pointer',
										color: canDownload(scope.row) ? '#d26300' : '#d26300',
										textDecoration: canDownload(scope.row)
											? 'underline'
											: 'underline',
									}">
										{{
											scope.row.is_loading
												? "Downloading..."
												: "Download Report"
										}} <i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="{type:'full', data: scope.row}">Full Report</el-dropdown-item>
										<el-dropdown-item :command="{type:'summary', data: scope.row}">Summary Report</el-dropdown-item>
										<el-dropdown-item :command="{type:'non_complaint', data: scope.row}">Non Complaint Report</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown> -->
								<div
									:style="{
										cursor: canDownload(scope.row) ? 'pointer' : 'not-allowed',
										color: canDownload(scope.row) ? '#d26300' : 'inherit',
										textDecoration: canDownload(scope.row)
											? 'underline'
											: 'none',
									}"
									@click="loading == false ? handleClick(scope.row) : '-'"
								>
										{{
											scope.row.is_loading
												? "Downloading..."
												: "Download Report"
										}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
						{{ reportsTable.length }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="reportsTable.length"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 20px; background: white; padding: 5px">
			<!-- <el-row style="margin-top: 20px">
				<el-col :span="10">
					<span style="font-weight: bold; margin-top: 20px; margin-left: 20px">
						Performance - By Category and Forms</span
					>
				</el-col>
				<el-col :span="4" :offset="1">
					<div>View By</div>
					<el-select
						style="margin-top: 10px"
						class="select"
						v-model="view_by_type"
						filterable
						placeholder="View By"
						@change="change_data_by_type()"
					>
						<el-option
							v-for="(item, key) in view_by_typeItems"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="4" :offset="1">
					<div>Type</div>
					<el-select
						style="margin-top: 10px"
						class="select"
						v-model="type"
						filterable
						placeholder="View By"
						@change="change_data_by_type()"
					>
						<el-option
							v-for="(item, key) in typeItems"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="5">
					<el-button
						icon="el-icon-download"
						style="margin-top: -8px; margin-left: 20px"
						class="button-class-new"
						@click="exportCSV"
					>
						Download Reports
					</el-button>
				</el-col>
			</el-row> -->
			<div style="display: flex; width: 100%; margin-top: 20px">
				<div style="width: 50%">
					<div style="font-weight: bold; margin-top: 30px; margin-left: 20px">
						Performance - By Category and Forms
					</div>
				</div>
				<div style="width: 15%; margin-left: 20px">
					<div>View By</div>
					<el-select
						style="margin-top: 10px"
						class="select"
						v-model="view_by_type"
						filterable
						placeholder="View By"
						@change="change_data_by_type()"
					>
						<el-option
							v-for="(item, key) in view_by_typeItems"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</div>
				<div style="width: 15%; margin-left: 20px">
					<div>Type</div>
					<el-select
						style="margin-top: 10px"
						class="select"
						v-model="type"
						filterable
						placeholder="View By"
						@change="change_data_by_type()"
					>
						<el-option
							v-for="(item, key) in typeItems"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</div>
				<div style="width: 10%">
					<el-button
						icon="el-icon-download"
						style="margin-top: 25px; margin-left: 20px"
						class="button-class-new"
						@click="exportCSV"
					>
						Download Reports
					</el-button>
				</div>
			</div>
			<el-row
				v-loading="isloading"
				class="TableWrapper overflow-table"
				style="margin-top: 14px"
			>
				<el-col :span="24">
					<table
						id="groupedTable"
						class="Table StickyTable"
						style="text-transform: capitalize; border-top: none"
					>
						<thead>
							<tr>
								<th class="light-border-bottom equal-text">
									{{ view_by_type == "form" ? "Forms" : "Category" }}
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Location"
											size="mini"
											:placeholder="`Search ${
												view_by_type == 'form' ? 'Forms' : 'Category'
											}`"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Location">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueLocationNamesMoM.filter(
														(el) =>
															!searched_Location ||
															el
																.toLowerCase()
																.includes(searched_Location.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Location = [...uniqueLocationNamesMoM]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Location = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Location.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</th>
								<template v-for="(head, key_2) in category_forms_items">
									<th
										:key="key_2 + '-occ' + head"
										class="light-border-bottom equal-text"
										style="text-align: left !important; width: 150px !important"
									>
										{{ moment(head.date, "YYYY-MM-DD").format("MMM, YY") }}
									</th>
								</template>
							</tr>
						</thead>
						<thead>
							<tr>
								<th class="light-border-bottom equal-text">Total</th>
								<th
									v-for="(item, key_3) in category_forms_items"
									:key="key_3 + '-tbl-row' + item"
								>
									{{ get_total_data(item, type) }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, key_22) in computedAllLocationsList.filter(
									(el, index) =>
										index >= startNumberMOM - 1 && index < endNumberMOM
								)"
								:key="key_22 + '-tbl-row' + item"
							>
								<td
									:key="key_22 + '-tbl-row' + item"
									class="light-border-bottom equal-text"
								>
									{{ item.name }}
								</td>
								<template v-for="(item_data, key_4) in category_forms_items">
									<td :key="key_4" class="light-border-bottom equal-text">
										{{ getMomTblData(item.name, item_data, type) }}
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumberMOM }} to {{ endNumberMOM }} of
						{{ computedAllLocationsList.length }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="computedAllLocationsList.length"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import UserPerformanceGraphVue from "./UserPerformanceGraph.vue";
import formBuilderServices from "../../../../services/formBuilderServices";
import TaskSkeletonLoader from "../../labourPlaninig/tasks/taskSkeletonLoader.vue";
import FiveKReport from "../../../UI/pdf/FiveKReport.vue";
import { EventBus } from "../../../../eventBus";
import { mapState, mapActions } from "vuex";
var moment = require("moment");
export default {
	components: {
		UserPerformanceGraphVue,
		TaskSkeletonLoader,
		FiveKReport,
	},
	props: {
		storeObj: Object,
		current_view: String,
		project_tasks: String,
		project_tasksItems: Array,
		from_date: null,
		to_date: null,
		view_by: String,
		show_fields: Array,
		is_outlet: Boolean,
		is_bt: Boolean,
		status: String,
	},
	data: () => ({
		moment: moment,
		is_summary_report: false,
		is_non_complaint_report: false,
		labels: [],
		country_average: [],
		region_average: [],
		chart_data: [],
		chart_data1: [],
		reportsTable: [],
		view_by_type: "form",
		view_by_typeItems: [
			{ name: "Forms", id: "form" },
			{ name: "Category", id: "form_category" },
		],
		type: "non_compliant",
		typeItems: [],
		isloading: false,
		performanceTable: [],
		SummaryreportsTable: [],
		category_forms_items: [],
		months: ["Jan", "Feb", "Mar" /* Add other months here */],
		items: {
			"item.name": { Jan: 10, Feb: 20, Mar: 15 },
			"item.name2": { Jan: 25, Feb: 18, Mar: 30 },
			// Add other items here
		},
		all_location_list: [],
		searched_Location: "",
		selected_Location: [],
		selected_Date: [],
		selected_Employee: [],
		selected_Designation: [],
		searched_Date: "",
		searched_end_Date: "",
		selected_end_Date: [],
		searched_completion_Date: "",
		selected_completion_Date: [],
		searched_Employee: "",
		selected_Designation: [],
		searched_Designation: "",
		searched_Region: "",
		selected_Region: [],
		selected_SubRegion: [],
		searched_SubRegion: "",
		currentPage: 1,
		perPage: 10,
		reportsTable2: [],
		show_score: false,
		show_completion: false,
		isDomLoading: false,
		chart_data: [],
		chart_data1: [],
		five_k_report_data: {},
		is_5k_data_loaded: false,
		EventBus: EventBus,
		loading: false,
	}),
	computed: {
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.reportsTable2.length
			);
			return end;
		},
		tableData() {
			return this.category_forms_items.map((item) => {
				const row = { name: "", entries: item.entries, date: item.date };
				row.name = item.entries.map((entry) => entry.name).join(", ");
				return row;
			});
		},
		computedAllLocationsList() {
			let arr = [...this.all_location_list];
			if (this.selected_Location.length) {
				arr = arr.filter((el) => this.selected_Location.includes(el.name));
			}
			return arr;
		},
		uniqueLocationNamesMoM() {
			let arr = [...new Set(this.all_location_list.map((el) => el.name))];
			return arr;
		},
		startNumberMOM() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumberMOM() {
			let end = Math.min(
				this.startNumberMOM + this.perPage - 1,
				this.computedAllLocationsList.length
			);
			return end;
		},
		uniqueDates() {
			let arr = [
				...new Set(
					this.reportsTable2.map((el) =>
						moment(el.project_start_date).format("Do MMM YYYY")
					)
				),
			];
			return arr;
		},
		uniqueDatesCompletion() {
			let arr = [
				...new Set(
					this.reportsTable2.map((el) =>
						moment(el.project_completion_date).format("Do MMM YYYY")
					)
				),
			];
			return arr;
		},
		uniqueDatesEnd() {
			let arr = [
				...new Set(
					this.reportsTable2.map((el) =>
						moment(el.project_end_date).format("Do MMM YYYY")
					)
				),
			];
			return arr;
		},
		uniqueEmployees() {
			let arr = [...new Set(this.reportsTable2.map((el) => el.name))];
			return arr;
		},
		uniqueDesignations() {
			let arr = [...new Set(this.reportsTable2.map((el) => el.designation))];
			return arr;
		},
		uniqueRegions() {
			let arr = [...new Set(this.reportsTable2.map((el) => el.region))];
			return arr;
		},
		uniqueSubRegions() {
			let arr = [...new Set(this.reportsTable2.map((el) => el.subregion))];
			return arr;
		},
		computedFiveKReportData() {
			let original_data = { ...this.five_k_report_data.project_execution };
			// if(this.checkCompany.is_bb && original_data.form_category_exeuctions){
			//     original_data.form_category_exeuctions.forEach((elm)=>{
			//         elm.form_executions.map((elm2) => {
			//             elm2.form_question_executions_data = (elm2.form_question_executions_data || []).filter((elm3) =>
			//                 elm3.task_status_update_info && elm3.task_status_update_info.current_score < 5
			//             );
			//         });
			//     });
			// }
			return original_data;
		},
		computedFiveKReportMetaData() {
			let original_data = { ...this.five_k_report_data.meta };
			return original_data;
		},
		computedFiveKReportPreviousData() {
			let original_data =
				this.five_k_report_data && this.five_k_report_data.previous_projects
					? [...this.five_k_report_data.previous_projects]
					: [];
			return original_data;
		},
	},
	created() {
		if (this.current_view == "Page_3") {
		}
	},
	mounted() {
		// if (this.current_view == "Page_3") {
		this.get_reports_table();
		this.labels = [];
		let labels = [];
		let chart_data = [];
		this.chart_data = [];
		let chart_data1 = [];
		this.chart_data1 = [];
		this.labels = labels;
		this.country_average = [];
		let country_average = [];
		for (let i = 0; i < labels.length; i++) {
			country_average.push(
				this.storeObj.response.country_average["completed_score_%"]
			);
		}
		this.country_average = country_average;
		this.region_average = [];
		let region_average = [];
		if (this.storeObj.response.region_average["completed_score_%"]) {
			for (let i = 0; i < labels.length; i++) {
				region_average.push(
					this.storeObj.response.region_average["completed_score_%"]
				);
			}
			this.region_average = region_average;
		}

		this.reportsTable = this.storeObj.response.data;
		this.reportsTable = [...this.reportsTable].sort(
			(a, b) =>
				this.moment(a.resample_date).format("x") -
				this.moment(b.resample_date).format("x")
		);
		for (let i = 0; i < this.reportsTable.length; i++) {
			labels.push(
				this.moment(this.reportsTable[i].resample_date).format("Do MMM YYYY")
			);
			// if (this.reportsTable[i].total_score != 0) {
			// 	chart_data.push(this.reportsTable[i]["completed_score_%"]);
			// }
			// chart_data1.push(this.reportsTable[i]["forms_completion_%"]);

			this.chart_data = chart_data;
			this.chart_data1 = chart_data1;
			this.$forceUpdate();
		}
		this.show_completion = false;
		this.show_score = false;
		for (let i = 0; i < this.show_fields.length; i++) {
			if (this.show_fields[i].includes("completion_%")) {
				this.show_completion = true;
			}
			if (this.show_fields[i].includes("score_%")) {
				this.show_score = true;
			}
		}
		if (this.show_score) {
			[...this.reportsTable].map((el) => {
				chart_data.push(el["completed_score_%"]);
			});
			this.typeItems = [
				{ name: "Non-Compliant", id: "non_compliant" },
				{ name: "Compliant", id: "compliant" },
				{ name: "Score %", id: "completed_score_%" },
			];
		}
		if (this.show_completion) {
			[...this.reportsTable].map((el) => {
				chart_data1.push(el["completion_%"]);
			});
			this.typeItems = [
				// { name: "Non-Compliant", id: "non_compliant" },
				// { name: "Compliant", id: "compliant" },
				{ name: "Completion %", id: "completion_%" },
			];
		}
		if (this.show_score && this.show_completion) {
			this.typeItems = [
				{ name: "Non-Compliant", id: "non_compliant" },
				{ name: "Compliant", id: "compliant" },
				{ name: "Score %", id: "completed_score_%" },
				{ name: "Completion %", id: "completion_%" },
			];
		}
		this.type = this.typeItems[0].id;
		this.reportsTable2 = [];
		setTimeout(() => {
			this.reportsTable2 = this.storeObj.response2
				? this.storeObj.response2
				: [];
			this.reportsTable2 = [...this.reportsTable2].sort(
				(a, b) =>
					new Date(a.project_start_date) - new Date(b.project_start_date)
			);
			this.$forceUpdate();
		}, 50);
		window.scrollTo(0, 0);
		// }
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		canDownload(row) {
			return row["forms_completion_%"] != 0 && !this.loading;
		},
		handleCommand(command) {
			command.data.is_loading = true;
			if (command.type === "full") {
				this.handleClick(command.data);
				this.is_summary_report = false;
				this.is_non_complaint_report = false;
			} else if (command.type === "summary") {
				this.handleClick(command.data);
				this.is_summary_report = true;
				this.is_non_complaint_report = false;
			} else if (command.type === "non_complaint") {
				this.handleClick(command.data);
				this.is_summary_report = false;
				this.is_non_complaint_report = true;
			}
		},
		async handleClick(row) {
			if (this.canDownload(row)) {
				this.loading = true;
				try {
					await this.downloadCsvReport(row);
				} catch (error) {
					console.error("Error downloading report:", error);
				} finally {
					// this.loading = false;
				}
			}
		},
		downloadFiveKReport(id, item) {
			let payload = { id: id };
			this.addDownloadingReportCountAction("Report");
			formBuilderServices
				.getFiveKReportPdfData(payload)
				.then((res) => {
					this.five_k_report_data = JSON.parse(res.data);
					this.is_5k_data_loaded = true;
					// this.removeDownloadingReportCountAction();
					this.loading = false;
					this.is_csv_loading = false;
					item.is_loading = false;
					if (
						this.is_5k_data_loaded &&
						this.five_k_report_data.project_execution
					) {
						this.$nextTick(() => {
							// this.processPdfDownload();
							EventBus.$emit("loadPdfFirst", {is_summary: this.is_summary_report, is_non_complaint: this.is_non_complaint_report});
							// this.$confirm('Your report has been successfully generated. Would you like to download it now?', 'Success', {
							// 	confirmButtonText: 'Download',
							// 	cancelButtonText: 'Cancel',
							// 	type: 'success',
							// 	customClass: 'ns-confirm-box',
							// }).then(() => {
							// 	setTimeout(() => {
							// 		EventBus.$emit('download5KPdf');
							// 	}, 500);
							// }).catch(() => {
							// 	this.$message({
							// 		type: 'info',
							// 		message: 'Download canceled. Feel free to download it later.'
							// 	});
							// });
						});
					}
				})
				.catch((err) => {
					console.error(err);
					this.loading = false;
					item.is_loading = false;
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
					this.is_5k_data_loaded = false;
					this.removeDownloadingReportCountAction();
				})
				.finally(() => {});
		},
		downloadCsvReport(item) {
			// this.addDownloadingReportCountAction("Report");
			// this.is_csv_loading = true; //displayed loader on button
			// // this.addDownloadingReportCountAction();
			// var params = {
			// 	project_execution: item.project_execution_id,
			// };
			// formBuilderServices
			// 	.getDashboarLocationReport(params)
			// 	.then((response) => {
			// 		// if (response.status == 200) {
			// 		// var fileURL = window.URL.createObjectURL(new Blob([response.data]));
			// 		let fileURL =
			// 			"data:application/pdf;charset=UTF-8," +
			// 			encodeURIComponent(response.data);
			// 		var fileLink = document.createElement("a");
			// 		fileLink.href = fileURL;
			// 		fileLink.setAttribute(
			// 			"download",
			// 			`${this.storeObj.name} - ${
			// 				`${
			// 					this.project_tasksItems.length != 0
			// 						? this.project_tasksItems.filter((el) =>
			// 								el.id.includes(this.project_tasks)
			// 						  )[0].name
			// 						: "-"
			// 				} - ` +
			// 				`${moment(this.from_date).format("Do MMM YYYY")}` +
			// 				"/" +
			// 				`${moment(this.to_date).format("Do MMM YYYY")}` +
			// 				".pdf"
			// 			}`
			// 		);
			// 		document.body.appendChild(fileLink);
			// 		fileLink.click();
			// 		// }
			// 		// this.removeDownloadingReportCountAction();
			// 		this.removeDownloadingReportCountAction();
			// 		this.is_csv_loading = false; //hide loader on button
			// 		this.loading = false;
			// 	})
			// 	.catch((err) => {
			// 		console.log(err);
			// 		this.is_csv_loading = false; //hide loader on button
			// 		// this.abortDownloadingReportCountAction();
			// 		this.loading = false;
			// 		this.removeDownloadingReportCountAction();
			// 		this.$notify.error({
			// 			title: "Error",
			// 			message: "Something went wrong!",
			// 		});
			// 	});
			this.downloadFiveKReport(item.project_execution_id, item);
		},
		exportCSV() {
			this.addDownloadingReportCountAction("Report");
			const uniqueNames = [
				...new Set(
					this.category_forms_items.flatMap((item) =>
						item.entries.map((entry) => entry.name)
					)
				),
			];
			const uniqueDates = [
				...new Set(this.category_forms_items.map((item) => item.date)),
			];
			// Create CSV content
			const csvContent = [];
			// Header row
			csvContent.push(
				[
					"name",
					...uniqueDates.map((date) => moment(date).format("MMMM YY")),
				].join(",")
			);
			// Data rows
			uniqueNames.forEach((name) => {
				const entriesWithName = [];

				uniqueDates.forEach((date) => {
					const entries = this.category_forms_items
						.filter((item) => item.date === date)
						.flatMap((item) => item.entries);
					const entriesWithNameDate = entries.filter(
						(entry) => entry.name === name
					);

					entriesWithName.push(...entriesWithNameDate);
				});
				// Use entriesWithName to get all entries for the name on all dates
				entriesWithName.forEach((entry) => {
					const rowData = [entry.name];
					uniqueDates.forEach((date) => {
						const entryOnDate = entriesWithName.find(
							(e) =>
								e.name === entry.name &&
								this.category_forms_items.some((item) => item.date === date)
						);
						rowData.push(entryOnDate ? entryOnDate[this.type] : ""); // Use compliant or '' as the value
					});
					csvContent.push(rowData.join(","));
				});
			});
			function formatDate(dateString) {
				return moment(dateString).format("MMM YYYY");
			}
			const firstEntryFormatted = formatDate(uniqueDates[0]);
			const lastEntryFormatted = formatDate(
				uniqueDates[uniqueDates.length - 1]
			);
			const blob = new Blob([csvContent.join("\n")], {
				type: "text/csv;charset=utf-8;",
			});
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = `${
				this.project_tasksItems.filter((el) =>
					el.id.includes(this.project_tasks)
				)[0].name
			} View By ${
				this.view_by_typeItems.filter((el) =>
					el.id.includes(this.view_by_type)
				)[0].name
			}_${
				this.typeItems.filter((el) => el.id.includes(this.type))[0].name
			}_${firstEntryFormatted}-${lastEntryFormatted}`;
			link.click();
			this.removeDownloadingReportCountAction();
		},
		change_data_by_type() {
			this.get_reports_table();
		},
		get_total_data(item, key) {
			let total = 0;
			if (key == "completion_%" || key == "completed_score_%") {
				for (let i = 0; i < item.entries.length; i++) {
					total += Number(item.entries[i][key]);
				}
				total = total / item.entries.length;
			} else {
				for (let i = 0; i < item.entries.length; i++) {
					total += Number(item.entries[i][key]);
				}
			}
			return total
				? key == "completion_%"
					? total.toFixed(2) + "%"
					: key == "completed_score_%"
					? total.toFixed(2) + "%"
					: total
				: 0;
		},
		getMomTblData(name, item_data, key) {
			const result = item_data.entries.find((e) => e.name === name);
			return result
				? key == "completion_%"
					? result[key] + "%"
					: key == "completed_score_%"
					? result[key] + "%"
					: result[key]
				: 0;
		},
		transformData() {
			const transformedData = [];
			for (const itemName in this.category_forms_items) {
				const item = this.items[itemName];
				const row = {
					itemName,
				};

				this.months.forEach((month) => {
					row[month] = item[month] || "-";
				});

				transformedData.push(row);
			}

			return transformedData;
		},
		go_back_to_dashboard() {
			this.$emit("clicked");
		},
		get_reports_table() {
			this.isDomLoading = true;
			this.all_location_list = [];
			this.category_forms_items = [];
			let params = this.storeObj.params;
			if (this.view_by_type == "form") params.basics = "form";
			if (this.view_by_type == "form_category") params.basics = "form_category";
			params.status = this.status !== "All" ? this.status : null;
			formBuilderServices.getDashboardData(params).then((res) => {
				let category_forms_items = JSON.parse(res.data).data;
				const groupedData = [...category_forms_items].reduce((acc, obj) => {
					const month = obj.resample_date.substring(0, 7); // Extracting the YYYY-MM part
					acc[month] = acc[month] || { date: month, total: {}, entries: [] };
					// Accumulate all key-value pairs dynamically
					Object.keys(obj).forEach((key) => {
						if (key !== "date") {
							acc[month].total[key] = (acc[month].total[key] || 0) + obj[key];
						}
					});
					acc[month].entries.push(obj);
					return acc;
				}, {});
				const result = Object.values(groupedData);
				if (result.length) {
					result[0].entries.forEach((el) => {
						this.all_location_list.push({
							name: el.name,
							basics: el.basics,
							total: el.total,
							completed: el.completed,
							total_score: el.total_score,
							"completed_score_%": el["completed_score_%"],
							"completion_%": el["completion_%"],
						});
					});
				}
				this.category_forms_items = result;
				this.isDomLoading = false;
			});

			// let array = [
			// 	{ date: "2024-01-22", compliant: 40 },
			// 	{ date: "2024-01-23", compliant: 30 },
			// 	{ date: "2024-01-24", compliant: 10 },
			// 	{ date: "2023-12-21", compliant: 50 },
			// 	{ date: "2023-11-20", compliant: 70 },
			// ];
		},

		get_reports_label(type) {
			if (type == "label")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].name
					: "";
			if (type == "occurance")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].total
					: "";
			if (type == "completed")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].completed
					: "";
			if (type == "completion")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0]["completion_%"] + "%"
					: "";
			if (type == "total")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].total_score
					: "";
			if (type == "achieved")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0].current_score
					: "";
			if (type == "score")
				return this.SummaryreportsTable[0] != undefined
					? this.SummaryreportsTable[0]["completed_score_%"] + "%"
					: "";
			this.$forceUpdate();
			return this.SummaryreportsTable;
		},
	},
};
</script>
<style lang="scss">
.reports-dashboard {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.reports-table3 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 62vh;
			max-height: 62vh;
		}
	}
}

.overflow-table {
	width: 100% !important;
	overflow-x: auto !important;
}
.Table {
	width: 100%;
	border-collapse: collapse;
}

.Table th {
	text-align: left;
	text-transform: uppercase;
	font-weight: 600;
	color: var(--MutedColor);
	font-size: var(--FontSizeS1);
}

.Table td,
.Table th {
	padding: 15px 10px;
	text-align: left;
	border-top: none;
	border-bottom: 1px solid #ebeef5;
	font-size: 12px;
}

.TableWrapper {
	width: 100%;
	height: 100%;
	overflow: auto;
}

.TableWrapper thead {
	white-space: nowrap;
}

.StickyTable {
	border-collapse: separate;
	border-spacing: 0;
}

.StickyTable thead th {
	position: sticky;
	top: 0;
	background: var(--CardBG);
}

.StickyTable tfoot td {
	position: sticky;
	bottom: 0;
	background: var(--CardBG);
}
:root {
	--dynamic-width: 390px; /* Define the CSS variable */
}
.dynamic-width {
	text-align: center !important;
	min-width: 390px !important;
	max-width: 390px !important;
	width: var(
		--dynamic-width,
		auto
	) !important; /* Position the element absolutely */
}
.dynamic-width2 {
	text-align: center !important;
	min-width: 260px !important;
	max-width: 260px !important;
	width: var(--dynamic-width2, auto) !important;
}
.dynamic-widthh1 {
	text-align: center !important;
	min-width: 130px !important;
	max-width: 130px !important;
	width: var(--dynamic-widthh1, auto) !important;
}
.dynamic-widthh2 {
	text-align: center !important;
	min-width: 130px !important;
	max-width: 130px !important;
	width: var(--dynamic-widthh2, auto) !important;
}
.dynamic-widthh3 {
	text-align: center !important;
	min-width: 110px !important;
	max-width: 110px !important;
	width: var(--dynamic-widthh3, auto) !important;
}
.vertical-divider {
	border-right: 1px solid #ccc; /* Adjust the style of the divider as needed */
}
</style>
